"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByPreferringTruthy = exports.sortByNumericValue = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var sortByNumericValue = exports.sortByNumericValue = function sortByNumericValue() {
  var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (value) {
    return value;
  };
  return function (a, b) {
    var _map$map = [a, b].map(function (c) {
        return Number(mapper(c));
      }).map(function (c) {
        return Number.isNaN(c) ? Number.POSITIVE_INFINITY : c;
      }),
      _map$map2 = (0, _slicedToArray2.default)(_map$map, 2),
      aValue = _map$map2[0],
      bValue = _map$map2[1];
    return aValue - bValue;
  };
};
var sortByPreferringTruthy = exports.sortByPreferringTruthy = function sortByPreferringTruthy() {
  var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (value) {
    return value;
  };
  return function (a, b) {
    var _map = [a, b].map(function (c) {
        return Number(!!mapper(c));
      }),
      _map2 = (0, _slicedToArray2.default)(_map, 2),
      aValue = _map2[0],
      bValue = _map2[1];
    return bValue - aValue;
  };
};